<template>
  <div class="mx-4">
    <div class="w-full flex justify-center">
      <img
        src="@/assets/images/offline_order.webp"
        class="w-72 mb-4"
        :alt="t('orders.offlineOrderTitle')"
      />
    </div>

    <NText
      variant="caption1"
      weight="regular"
      class="text-neutral-tertiary-hover"
    >
      {{ t('orders.offlineOrderDescription') }}
    </NText>

    <ul class="list-disc list-inside p-2">
      <template v-for="(item, index) of OFFLINE_ORDER_HINT" :key="index">
        <li>
          <NText variant="caption1">{{ item }}</NText>
        </li>
      </template>
    </ul>

    <a
      v-gid="{
        module: 'order',
        screen: 'home',
        section: 'offlineOrderDescriptionDialog',
        component: `moreInformationLink`,
      }"
      :href="OFFLINE_ORDER_MORE_INFORMATION_LINK"
      target="_blank"
      class="mt-1"
    >
      <NButton variant="flat" color="green" size="mini" class="!rounded-full">
        <NText variant="overline" weight="medium">
          {{ t('common.moreInformation') }}
        </NText>
      </NButton>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { OFFLINE_ORDER_MORE_INFORMATION_LINK } from '@/modules/order';

const { t } = useI18n();

const OFFLINE_ORDER_HINT = [
  t('orders.offlineOrderConditions.allowedTimeMessage'),
  t('orders.offlineOrderConditions.preOrderLimitationMessage'),
  t('orders.offlineOrderConditions.validityTimeMessage'),
];
</script>
